// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Темная тема (по умолчанию) */
body.dh-theme-dark .social-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

/* Светлая тема */
body.dh-theme-light .social-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: relative;
}

/* Светлая тема - заголовки страниц */
body.dh-theme-light .social-content-title {
  color: #002FA7;
}

body.dh-theme-light .social-content-subtitle {
  color: #002FA7;
  font-weight: 500;
}

/* Для темной темы сохраняем белый цвет */
body.dh-theme-dark .social-content-title {
  color: white;
}

body.dh-theme-dark .social-content-subtitle {
  color: white;
}

body.dh-theme-light .th-dropdown-user-info .th-user-gradient-bg {
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  opacity: 1;
  z-index: -1;
}

body.dh-theme-light .th-dropdown-fullname{
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0d2e82;
  margin-bottom: 4px;
}

body.dh-theme-light .th-dropdown-department{
  display: block;
  font-size: 13px;
  color: #002FA7;
  font-weight: 400;
}

* {
  font-family: 'Montserrat', sans-serif !important;
  box-sizing: border-box;
}

.social-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

.social-content {
  position: relative;
  z-index: 1;
  padding: 20px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* Анимированный фон */
.social-background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.social-shape {
  position: absolute;
  opacity: 0.1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: social-float 20s infinite linear;
  filter: blur(20px);
}

.social-shape-1 { 
  width: 300px; 
  height: 300px; 
  top: 10%; 
  left: 5%; 
  animation-delay: 0s;
}

.social-shape-2 { 
  width: 250px; 
  height: 250px; 
  top: 60%; 
  right: 10%; 
  animation-delay: -5s;
}

.social-shape-3 { 
  width: 200px; 
  height: 200px; 
  bottom: 15%; 
  left: 20%; 
  animation-delay: -10s;
}

@keyframes social-float {
  0%, 100% { 
    transform: translateY(0) rotate(0deg); 
  }
  25% { 
    transform: translateY(-20px) rotate(90deg); 
  }
  50% { 
    transform: translateY(0) rotate(180deg); 
  }
  75% { 
    transform: translateY(20px) rotate(270deg); 
  }
}

/* Основной контент */
.social-main {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  width: 100%;
  margin-top: 20px;
  transition: grid-template-columns 0.3s ease;
}

.social-main.sidebar-collapsed {
  grid-template-columns: 80px 1fr;
}

/* Боковая панель */
.social-sidebar {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 520px;
  position: relative;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.social-sidebar.collapsed {
  width: 80px;
  padding: 24px 16px;
  align-items: center;
  display: flex;
  justify-content: flex-start;
  height: 560px;
  z-index: 1;
}

/* Модальные окна групп - ниже сайдбара */
.pc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  backdrop-filter: blur(4px);
}

.social-sidebar.collapsed .social-sidebar-header,
.social-sidebar.collapsed .social-nav-text,
.social-sidebar.collapsed .social-sidebar-footer,
.social-sidebar.collapsed .social-nav-indicator {
  display: none;
}

.social-sidebar.collapsed .social-sidebar-nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 100%;
  margin-top: 0;
}

.social-sidebar.collapsed .social-nav-item {
  width: 52px;
  height: 52px;
  padding: 0;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  display: flex;
  position: relative;
  margin: 0;
}

.social-sidebar.collapsed .social-nav-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: 100%;
  height: 100%;
}

.social-sidebar.collapsed .social-nav-svg-icon {
  width: 34px;
  height: 34px;
  display: block;
  margin: auto;
}

.social-sidebar.collapsed .social-nav-item:hover::after {
  opacity: 1;
}

.t-sidebar.collapsed .sidebar-toggle {
  transform: rotate(180deg);
}

/* Кнопка сворачивания */
.s-sidebar-toggle {
  position: absolute;
  top: 16px;
  right: -12px;
  width: 24px;
  height: 24px;
  border: 2px solid;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 2;
}

.s-sidebar-toggle:hover {

  transform: scale(1.1);
  background-color: white;  
}


.social-sidebar.collapsed .s-sidebar-toggle {
  transform: rotate(180deg);
}


/* Контент боковой панели - как у преподавателя */
.social-sidebar-header {
  text-align: center;
  margin-bottom: 24px;
  margin-top: 14px;
}

.social-user-fullname-small {
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 20px 0;
  line-height: 1.3;
}

.social-user-info .social-user-role {
  color: #002FA7;
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0;
}

.social-user-department {
  color: #002FA7;
  font-size: 12px;
  font-weight: 300;
  margin: 4px 0 20px 0;
}

/* Навигация - как у преподавателя */
.social-sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  flex: 1 1;
}

.social-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: none;
  background: transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.social-nav-item:hover {
  background: rgba(0, 47, 167, 0.1);
}

.social-nav-item.active {
  background: rgba(102, 126, 234, 0.15);
  font-weight: 600;
}

.social-nav-item.active .social-nav-text {
  color: #002FA7;
}

.social-nav-text {
  font-size: 14px;
  color: #002FA7;
  font-weight: 500;
}

.social-nav-indicator {
  width: 3px;
  height: 24px;
  background: #002FA7;
  border-radius: 2px;
  position: absolute;
  right: -24px;
}

/* Иконки */
.social-nav-svg-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}

/* Основная область контента */
.social-content-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  z-index: 3;
  position: relative;
}

.social-content-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  flex-wrap: nowrap;
  min-width: 0;
}

.social-content-title {
  color: white;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  flex-shrink: 0;
}

.social-content-subtitle {
  color: white;
  font-weight: 200;
  font-size: 14px;
  margin-top: 24px;
  margin-left: 20px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.social-content-card {
  background: white;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  min-height: 550px;
  width: 100%;
  z-index: 1;
  position: relative;
}

/* Адаптивность */
@media (max-width: 1200px) {
  .social-content {
    padding: 16px;
    max-width: 95vw;
  }
}

@media (max-width: 1024px) {
  .social-main {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .social-main.sidebar-collapsed {
    grid-template-columns: 1fr;
  }
  
  .social-sidebar {
    order: 2;
    min-height: auto;
    height: auto;
    position: static;
  }
  
  .social-sidebar.collapsed {
    width: 100%;
    padding: 20px;
    flex-direction: row;
    align-items: center;
    height: auto;
  }
  
  .social-sidebar.collapsed .social-sidebar-nav {
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    margin: 0;
  }
  
  .social-sidebar.collapsed .social-nav-item {
    width: 60px;
    height: 60px;
  }
  
  .social-content-area {
    order: 1;
  }
  
  .social-nav-indicator,
  .social-sidebar-toggle {
    display: none;
  }
  
  .social-content-card {
    min-height: 500px;
  }
}

@media (max-width: 768px) {
  .social-content {
    padding: 12px;
  }
  
  .social-content-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    flex-wrap: wrap;
  }
  
  .social-content-title {
    font-size: 22px;
    white-space: normal;
  }
  
  .social-content-subtitle {
    margin-left: 0;
    font-size: 13px;
    white-space: normal;
  }
  
  .social-content-card {
    padding: 16px;
    min-height: 500px;
  }
  
  .social-sidebar {
    padding: 20px;
  }
  
  .social-sidebar.collapsed {
    padding: 16px;
  }
  
  .social-sidebar.collapsed .social-nav-item {
    width: 50px;
    height: 50px;
  }
  
  .social-nav-svg-icon {
    width: 22px;
    height: 22px;
  }
}

@media (max-width: 480px) {
  .social-content {
    padding: 8px;
  }
  
  .social-main {
    gap: 16px;
    margin-top: 20px;
  }
  
  .social-sidebar {
    padding: 16px;
    border-radius: 16px;
  }
  
  .social-content-card {
    padding: 12px;
    border-radius: 16px;
    min-height: 450px;
  }
  
  .social-content-title {
    font-size: 20px;
    gap: 8px;
  }
  
  .social-user-fullname-small {
    font-size: 16px;
  }
  
  .social-sidebar.collapsed .social-nav-item {
    width: 44px;
    height: 44px;
  }
  
  .social-nav-svg-icon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 360px) {
  .social-sidebar.collapsed .social-nav-item {
    width: 40px;
    height: 40px;
  }
  
  .social-nav-svg-icon {
    width: 18px;
    height: 18px;
  }
  
  .social-content-title {
    font-size: 18px;
  }
  
  .social-content-subtitle {
    font-size: 12px;
  }
}

/* Блок расписания - МИНИМАЛИСТИЧНЫЙ */
.social-sidebar-footer {
  padding-top: 0;
  width: 100%;
}

.social-schedule-mini {
  background: linear-gradient(135deg, #002FA7, #5986f7);
  border-radius: 12px;
  padding: 10px;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.2);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.social-schedule-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
}

.social-schedule-row-label {
  display: flex;
  gap: 8px;
  white-space: nowrap;
}

.social-schedule-day {
  font-weight: 500;
  color: white;
  opacity: 0.8;
  font-size: 11px;
  text-transform: lowercase;
}

.social-schedule-day.today {
  font-weight: 800;
  opacity: 1;
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
}

.social-schedule-row-divider {
  color: white;
  opacity: 0.3;
  margin: 0 4px;
  font-weight: 300;
}

.social-schedule-row-rooms {
  display: flex;
  gap: 8px;
  white-space: nowrap;
}

.social-schedule-room-mini {
  font-weight: 600;
  color: white;
  background: rgba(255, 255, 255, 0.15);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
}

.social-schedule-room-mini.today {
  background: white;
  color: #002FA7;
  font-weight: 700;
}

/* Подсказка для настройки расписания */
.schedule-edit-hint {
  font-size: 9px;
  text-align: center;
  margin-top: 6px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.social-schedule-mini {
  cursor: pointer;
  transition: all 0.2s ease;
}

.social-schedule-mini:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.social-schedule-mini:hover .schedule-edit-hint {
  opacity: 1;
}


.schedule-placeholder {
  width: 100px;
}

/* Модальное окно настройки расписания */
.schedule-config-modal {
  max-width: 650px;
  width: 90%;
}

.schedule-header {
  display: grid;
  grid-template-columns: 100px repeat(5, 1fr);
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e0e7ff;
}

.schedule-day-header {
  text-align: center;
  font-weight: 600;
  color: #002FA7;
  font-size: 14px;
  padding: 8px;
  background: #f0f4ff;
  border-radius: 8px;
}

.schedule-rooms-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 8px;
}

.schedule-room-row {
  display: grid;
  grid-template-columns: 100px repeat(5, 1fr);
  gap: 8px;
  align-items: center;
  padding: 10px;
  background: #f8f9ff;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.schedule-room-row:hover {
  background: #eef2ff;
}

.schedule-room-name {
  font-weight: 600;
  color: #002FA7;
  font-size: 14px;
  padding-left: 8px;
}

.schedule-room-days {
  display: contents;
}

.schedule-day-checkbox {
  width: 32px;
  height: 32px;
  margin: 0 auto;
  border: 2px solid #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: white;
}

.schedule-day-checkbox:hover {
  border-color: #002FA7;
  background: #e0e7ff;
}

.schedule-day-checkbox.checked {
  background: #002FA7;
  border-color: #002FA7;
}

.check-mark {
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.schedule-note {
  font-size: 12px;
  color: #666;
  margin-top: 16px;
  padding: 8px;
  background: #f0f4ff;
  border-radius: 8px;
  text-align: center;
}

/* Адаптивность для модального окна */
@media (max-width: 600px) {
  .schedule-config-modal {
    width: 95%;
  }
  
  .schedule-header {
    grid-template-columns: 80px repeat(5, 1fr);
    gap: 4px;
  }
  
  .schedule-room-row {
    grid-template-columns: 80px repeat(5, 1fr);
    gap: 4px;
    padding: 8px;
  }
  
  .schedule-room-name {
    font-size: 12px;
    padding-left: 4px;
  }
  
  .schedule-day-checkbox {
    width: 28px;
    height: 28px;
  }
  
  .schedule-day-header {
    font-size: 12px;
    padding: 4px;
  }
  
  .check-mark {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .schedule-day-checkbox {
    width: 24px;
    height: 24px;
  }
  
  .schedule-room-name {
    font-size: 11px;
  }
  
  .schedule-day-header {
    font-size: 10px;
  }
}

* {
  box-sizing: border-box;
}

html, body, #root {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/SocialPage.css"],"names":[],"mappings":"AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;EACZ;;EAEA;IACE,0CAA0C;IAC1C,QAAQ;EACV;;EAEA;IACE,0CAA0C;IAC1C,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n/* Темная тема (по умолчанию) */\nbody.dh-theme-dark .social-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n/* Светлая тема */\nbody.dh-theme-light .social-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: relative;\n}\n\n/* Светлая тема - заголовки страниц */\nbody.dh-theme-light .social-content-title {\n  color: #002FA7;\n}\n\nbody.dh-theme-light .social-content-subtitle {\n  color: #002FA7;\n  font-weight: 500;\n}\n\n/* Для темной темы сохраняем белый цвет */\nbody.dh-theme-dark .social-content-title {\n  color: white;\n}\n\nbody.dh-theme-dark .social-content-subtitle {\n  color: white;\n}\n\nbody.dh-theme-light .th-dropdown-user-info .th-user-gradient-bg {\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  opacity: 1;\n  z-index: -1;\n}\n\nbody.dh-theme-light .th-dropdown-fullname{\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0d2e82;\n  margin-bottom: 4px;\n}\n\nbody.dh-theme-light .th-dropdown-department{\n  display: block;\n  font-size: 13px;\n  color: #002FA7;\n  font-weight: 400;\n}\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n  box-sizing: border-box;\n}\n\n.social-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n.social-content {\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Анимированный фон */\n.social-background-animation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.social-shape {\n  position: absolute;\n  opacity: 0.1;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  animation: social-float 20s infinite linear;\n  filter: blur(20px);\n}\n\n.social-shape-1 { \n  width: 300px; \n  height: 300px; \n  top: 10%; \n  left: 5%; \n  animation-delay: 0s;\n}\n\n.social-shape-2 { \n  width: 250px; \n  height: 250px; \n  top: 60%; \n  right: 10%; \n  animation-delay: -5s;\n}\n\n.social-shape-3 { \n  width: 200px; \n  height: 200px; \n  bottom: 15%; \n  left: 20%; \n  animation-delay: -10s;\n}\n\n@keyframes social-float {\n  0%, 100% { \n    transform: translateY(0) rotate(0deg); \n  }\n  25% { \n    transform: translateY(-20px) rotate(90deg); \n  }\n  50% { \n    transform: translateY(0) rotate(180deg); \n  }\n  75% { \n    transform: translateY(20px) rotate(270deg); \n  }\n}\n\n/* Основной контент */\n.social-main {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  width: 100%;\n  margin-top: 20px;\n  transition: grid-template-columns 0.3s ease;\n}\n\n.social-main.sidebar-collapsed {\n  grid-template-columns: 80px 1fr;\n}\n\n/* Боковая панель */\n.social-sidebar {\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  height: 520px;\n  position: relative;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.social-sidebar.collapsed {\n  width: 80px;\n  padding: 24px 16px;\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n  height: 560px;\n  z-index: 1;\n}\n\n/* Модальные окна групп - ниже сайдбара */\n.pc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  backdrop-filter: blur(4px);\n}\n\n.social-sidebar.collapsed .social-sidebar-header,\n.social-sidebar.collapsed .social-nav-text,\n.social-sidebar.collapsed .social-sidebar-footer,\n.social-sidebar.collapsed .social-nav-indicator {\n  display: none;\n}\n\n.social-sidebar.collapsed .social-sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  height: 100%;\n  margin-top: 0;\n}\n\n.social-sidebar.collapsed .social-nav-item {\n  width: 52px;\n  height: 52px;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n  display: flex;\n  position: relative;\n  margin: 0;\n}\n\n.social-sidebar.collapsed .social-nav-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.social-sidebar.collapsed .social-nav-svg-icon {\n  width: 34px;\n  height: 34px;\n  display: block;\n  margin: auto;\n}\n\n.social-sidebar.collapsed .social-nav-item:hover::after {\n  opacity: 1;\n}\n\n.t-sidebar.collapsed .sidebar-toggle {\n  transform: rotate(180deg);\n}\n\n/* Кнопка сворачивания */\n.s-sidebar-toggle {\n  position: absolute;\n  top: 16px;\n  right: -12px;\n  width: 24px;\n  height: 24px;\n  border: 2px solid;\n  border-radius: 50%;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.s-sidebar-toggle:hover {\n\n  transform: scale(1.1);\n  background-color: white;  \n}\n\n\n.social-sidebar.collapsed .s-sidebar-toggle {\n  transform: rotate(180deg);\n}\n\n\n/* Контент боковой панели - как у преподавателя */\n.social-sidebar-header {\n  text-align: center;\n  margin-bottom: 24px;\n  margin-top: 14px;\n}\n\n.social-user-fullname-small {\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  line-height: 1.3;\n}\n\n.social-user-info .social-user-role {\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 10px 0;\n}\n\n.social-user-department {\n  color: #002FA7;\n  font-size: 12px;\n  font-weight: 300;\n  margin: 4px 0 20px 0;\n}\n\n/* Навигация - как у преподавателя */\n.social-sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n  flex: 1;\n}\n\n.social-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border: none;\n  background: transparent;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.social-nav-item:hover {\n  background: rgba(0, 47, 167, 0.1);\n}\n\n.social-nav-item.active {\n  background: rgba(102, 126, 234, 0.15);\n  font-weight: 600;\n}\n\n.social-nav-item.active .social-nav-text {\n  color: #002FA7;\n}\n\n.social-nav-text {\n  font-size: 14px;\n  color: #002FA7;\n  font-weight: 500;\n}\n\n.social-nav-indicator {\n  width: 3px;\n  height: 24px;\n  background: #002FA7;\n  border-radius: 2px;\n  position: absolute;\n  right: -24px;\n}\n\n/* Иконки */\n.social-nav-svg-icon {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n}\n\n/* Основная область контента */\n.social-content-area {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  z-index: 3;\n  position: relative;\n}\n\n.social-content-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.social-content-title {\n  color: white;\n  font-size: 26px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  margin-left: 4px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.social-content-subtitle {\n  color: white;\n  font-weight: 200;\n  font-size: 14px;\n  margin-top: 24px;\n  margin-left: 20px;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.social-content-card {\n  background: white;\n  border-radius: 20px;\n  padding: 28px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  min-height: 550px;\n  width: 100%;\n  z-index: 1;\n  position: relative;\n}\n\n/* Адаптивность */\n@media (max-width: 1200px) {\n  .social-content {\n    padding: 16px;\n    max-width: 95vw;\n  }\n}\n\n@media (max-width: 1024px) {\n  .social-main {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .social-main.sidebar-collapsed {\n    grid-template-columns: 1fr;\n  }\n  \n  .social-sidebar {\n    order: 2;\n    min-height: auto;\n    height: auto;\n    position: static;\n  }\n  \n  .social-sidebar.collapsed {\n    width: 100%;\n    padding: 20px;\n    flex-direction: row;\n    align-items: center;\n    height: auto;\n  }\n  \n  .social-sidebar.collapsed .social-sidebar-nav {\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-around;\n    margin: 0;\n  }\n  \n  .social-sidebar.collapsed .social-nav-item {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .social-content-area {\n    order: 1;\n  }\n  \n  .social-nav-indicator,\n  .social-sidebar-toggle {\n    display: none;\n  }\n  \n  .social-content-card {\n    min-height: 500px;\n  }\n}\n\n@media (max-width: 768px) {\n  .social-content {\n    padding: 12px;\n  }\n  \n  .social-content-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n  \n  .social-content-title {\n    font-size: 22px;\n    white-space: normal;\n  }\n  \n  .social-content-subtitle {\n    margin-left: 0;\n    font-size: 13px;\n    white-space: normal;\n  }\n  \n  .social-content-card {\n    padding: 16px;\n    min-height: 500px;\n  }\n  \n  .social-sidebar {\n    padding: 20px;\n  }\n  \n  .social-sidebar.collapsed {\n    padding: 16px;\n  }\n  \n  .social-sidebar.collapsed .social-nav-item {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .social-nav-svg-icon {\n    width: 22px;\n    height: 22px;\n  }\n}\n\n@media (max-width: 480px) {\n  .social-content {\n    padding: 8px;\n  }\n  \n  .social-main {\n    gap: 16px;\n    margin-top: 20px;\n  }\n  \n  .social-sidebar {\n    padding: 16px;\n    border-radius: 16px;\n  }\n  \n  .social-content-card {\n    padding: 12px;\n    border-radius: 16px;\n    min-height: 450px;\n  }\n  \n  .social-content-title {\n    font-size: 20px;\n    gap: 8px;\n  }\n  \n  .social-user-fullname-small {\n    font-size: 16px;\n  }\n  \n  .social-sidebar.collapsed .social-nav-item {\n    width: 44px;\n    height: 44px;\n  }\n  \n  .social-nav-svg-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 360px) {\n  .social-sidebar.collapsed .social-nav-item {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .social-nav-svg-icon {\n    width: 18px;\n    height: 18px;\n  }\n  \n  .social-content-title {\n    font-size: 18px;\n  }\n  \n  .social-content-subtitle {\n    font-size: 12px;\n  }\n}\n\n/* Блок расписания - МИНИМАЛИСТИЧНЫЙ */\n.social-sidebar-footer {\n  padding-top: 0;\n  width: 100%;\n}\n\n.social-schedule-mini {\n  background: linear-gradient(135deg, #002FA7, #5986f7);\n  border-radius: 12px;\n  padding: 10px;\n  color: white;\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.2);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.social-schedule-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n}\n\n.social-schedule-row-label {\n  display: flex;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.social-schedule-day {\n  font-weight: 500;\n  color: white;\n  opacity: 0.8;\n  font-size: 11px;\n  text-transform: lowercase;\n}\n\n.social-schedule-day.today {\n  font-weight: 800;\n  opacity: 1;\n  text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);\n}\n\n.social-schedule-row-divider {\n  color: white;\n  opacity: 0.3;\n  margin: 0 4px;\n  font-weight: 300;\n}\n\n.social-schedule-row-rooms {\n  display: flex;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.social-schedule-room-mini {\n  font-weight: 600;\n  color: white;\n  background: rgba(255, 255, 255, 0.15);\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n}\n\n.social-schedule-room-mini.today {\n  background: white;\n  color: #002FA7;\n  font-weight: 700;\n}\n\n/* Подсказка для настройки расписания */\n.schedule-edit-hint {\n  font-size: 9px;\n  text-align: center;\n  margin-top: 6px;\n  opacity: 0.6;\n  transition: opacity 0.2s ease;\n}\n\n.social-schedule-mini {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.social-schedule-mini:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.social-schedule-mini:hover .schedule-edit-hint {\n  opacity: 1;\n}\n\n\n.schedule-placeholder {\n  width: 100px;\n}\n\n/* Модальное окно настройки расписания */\n.schedule-config-modal {\n  max-width: 650px;\n  width: 90%;\n}\n\n.schedule-header {\n  display: grid;\n  grid-template-columns: 100px repeat(5, 1fr);\n  gap: 8px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e0e7ff;\n}\n\n.schedule-day-header {\n  text-align: center;\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 14px;\n  padding: 8px;\n  background: #f0f4ff;\n  border-radius: 8px;\n}\n\n.schedule-rooms-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.schedule-room-row {\n  display: grid;\n  grid-template-columns: 100px repeat(5, 1fr);\n  gap: 8px;\n  align-items: center;\n  padding: 10px;\n  background: #f8f9ff;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n}\n\n.schedule-room-row:hover {\n  background: #eef2ff;\n}\n\n.schedule-room-name {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 14px;\n  padding-left: 8px;\n}\n\n.schedule-room-days {\n  display: contents;\n}\n\n.schedule-day-checkbox {\n  width: 32px;\n  height: 32px;\n  margin: 0 auto;\n  border: 2px solid #cbd5e1;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.schedule-day-checkbox:hover {\n  border-color: #002FA7;\n  background: #e0e7ff;\n}\n\n.schedule-day-checkbox.checked {\n  background: #002FA7;\n  border-color: #002FA7;\n}\n\n.check-mark {\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.schedule-note {\n  font-size: 12px;\n  color: #666;\n  margin-top: 16px;\n  padding: 8px;\n  background: #f0f4ff;\n  border-radius: 8px;\n  text-align: center;\n}\n\n/* Адаптивность для модального окна */\n@media (max-width: 600px) {\n  .schedule-config-modal {\n    width: 95%;\n  }\n  \n  .schedule-header {\n    grid-template-columns: 80px repeat(5, 1fr);\n    gap: 4px;\n  }\n  \n  .schedule-room-row {\n    grid-template-columns: 80px repeat(5, 1fr);\n    gap: 4px;\n    padding: 8px;\n  }\n  \n  .schedule-room-name {\n    font-size: 12px;\n    padding-left: 4px;\n  }\n  \n  .schedule-day-checkbox {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .schedule-day-header {\n    font-size: 12px;\n    padding: 4px;\n  }\n  \n  .check-mark {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .schedule-day-checkbox {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .schedule-room-name {\n    font-size: 11px;\n  }\n  \n  .schedule-day-header {\n    font-size: 10px;\n  }\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  overflow-x: hidden;\n  width: 100%;\n  max-width: 100vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
